module.exports = __webpack_public_path__ + "img/浅框.f024aa59.png";